import Vue from "@/main";
import { Message } from "element-ui";

import czmlUrl from "./car.json";
import lujing_01 from "./lujing_01.json";
import lujing_02 from "./lujing_02.json";
import thePath from "./thePath.json";

export let graphicLayer; // 矢量图层对象
export let graphicLayer2; // 矢量图层对象
let positions = []; //
let savePaths = []; // 路径
let indexs = 1;
let basePathUrl = window.basePathUrl || "";
let pathData = [];
let vehicleSum = 100;
let carVelocity = 3;
let intervalDate = 3;
let CzmlLayerData;
let layerGarp;
let layerGarp2;
// 时间格式 ISO 8601   // console.log(new Date("2018-11-14 16:40:00").toISOString());
let beginDate = "2018-11-14T08:40:00.000Z";
let endDate = "2018-11-14T08:50:10.000Z";

graphicLayer = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer);

graphicLayer2 = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer2);

//汽车模型 gltf
let automobileList = [
  {
    url: "benchi1.gltf",
  },
  {
    url: "benchi2.gltf",
  },
  {
    url: "red_car.gltf",
  },
  {
    url: "suv.gltf",
  },
  {
    url: "kache1.gltf",
  },
  {
    url: "paoche1.gltf",
  },
  {
    url: "benchi3.gltf",
  },
  // {
  //   url: "qiche1.gltf",
  // },
  // {
  //   url: "jiaobanche.glb",
  // },

  // {
  //   url: "kache3.gltf",
  // },
  // {
  //   url: "bus2.gltf",
  // },
  // {
  //   url: "zhatuche.glb",
  // },
  // {
  //   url: "xiaofangche.gltf",
  // },
];
//车牌号所在地区
let citys = [
  "京",
  "津",
  "晋",
  "湘",
  "赣",
  "沪",
  "渝",
  "冀",
  "台",
  "辽",
  "吉",
  "黑",
  "苏",
  "浙",
  "皖",
  "闽",
  "鲁",
  "豫",
  "鄂",
  "青",
  "粤",
  "琼",
  "川",
  "贵",
  "云",
  "陕",
  "甘",
  "藏",
  "桂",
  "蒙",
  "宁",
  "新",
  "港",
  "澳",
];
//车牌号所在地区
let area = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
];
//车牌号后5位
let nums = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];
export function pathDataFun() {
  var pathData = [];
  let arr = JSON.parse(
    JSON.stringify(lujing_01.features[0].geometry.coordinates)
  );

  console.log(pathData, "pathData");

  for (let i = 0; i < arr.length; i++) {
    arr[i].unshift(999999);
    for (let v = 0; v < arr[i].length; v++) {
      pathData.push(arr[i][v]);
    }
  }
  savePaths.push(pathData);
  console.log(savePaths, "第一条第一条第一条第一条");
}

export function pathDataFun2() {
  var pathData = [];
  let arr = JSON.parse(
    JSON.stringify(lujing_02.features[0].geometry.coordinates)
  );

  for (let i = 0; i < arr.length; i++) {
    arr[i].unshift(999999);
    for (let v = 0; v < arr[i].length; v++) {
      pathData.push(arr[i][v]);
    }
  }
  savePaths.push(pathData);
  console.log(savePaths, "第二条第二条第二条第二条");
}
// 113.93543348699828, 22.524515811414847;

// Vue.$GLOBAL.map.on(mars3d.EventType.cameraMoveEnd, function (data) {
//   console.log("相机移动*********", data);
//   let alt = Vue.$GLOBAL.map.getCameraView({ simplify: true });
//   console.log(alt);
//   if (alt.alt < 1300) {
//     //打开汽车模型
//     controlModel(true);
//   } else {
//     //关闭汽车模型
//     controlModel(false);
//   }
// });

// 地图选点
export function setPoint() {
  graphicLayer.startDraw({
    type: "polyline",
    style: {
      color: "#55ff33",
      width: 3,
      // pixelSize: 5,
      // outlineColor: "#ffffff",
      // outlineWidth: 2,
      clampToGround: false,
      classificationType: Cesium.ClassificationType.CESIUM_3D_TILE,
      visibleDepth: false, //是否被遮挡
    },
    classificationType: Cesium.ClassificationType.CESIUM_3D_TILE,
    // style: {
    //   color: "#00ffff",
    //   width: 3,
    //   visibleDepth: false, //是否被遮挡
    //   clampToGround: false,
    //   label: {
    //     // 不需要文字时，去掉label配置即可
    //     text: indexs.toString(),
    //     font_size: 20,
    //     color: "#ffffff",
    //     outline: true,
    //     outlineColor: "#000000",
    //     pixelOffsetY: -20,
    //   },
    // },
    addHeight: 0.5,
    // success: (graphic) => {
    //   let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
    //     graphic._position_draw
    //   );
    //   // alt 高度（单位：米） lat 纬度  lng 经度
    //   positions.push(999999);
    //   positions.push(_lng);
    //   positions.push(_lat);
    //   positions.push(_alt);
    //   // positions.push([time, _lng, _lat, _alt]);
    //   indexs += 1;
    // },
    //线
    success: (graphic) => {
      console.log(graphic);
      for (let i = 0; i < graphic._positions_draw.length; i++) {
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          graphic._positions_draw[i]
        );
        // alt 高度（单位：米） lat 纬度  lng 经度
        positions.push(999999);
        positions.push(_lng);
        positions.push(_lat);
        positions.push(_alt);

        addDot(_lng, _lat, _alt);
        indexs += 1;
        // positions.push([time, _lng, _lat, _alt]);
        console.log(positions, "positions");
      }
    },
  });

  // 点
  // graphicLayer.on(mars3d.EventType.drawAddPoint, function (event) {
  //   console.log("矢量数据对象加载完成", event);
  //   addDot(event.cartesian);
  //   indexs += 1;
  // });
}

function addDot(_lng, _lat, _alt) {
  // :113.93096937, 纬度:22.55751304,
  // let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(item);
  // console.log(_lng);
  // console.log(_lat);
  // let arr = [113.93096937, 22.55751304, 0];
  let arr = [_lng, _lat, _alt];
  console.log(arr, "arr");
  let graphic = new mars3d.graphic.PointEntity({
    position: arr,
    isPrivate: true,
    style: {
      color: "#ff0000",
      pixelSize: 10,
      outlineColor: "#ffffff",
      outlineWidth: 2,
      // classificationType: Cesium.ClassificationType.CESIUM_3D_TILE,
      visibleDepth: false, //是否被遮挡
      label: {
        text: indexs.toString(),
        font_size: 18,
        color: "#ffffff",
        pixelOffsetY: -20,
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 500000,
        distanceDisplayCondition_near: 0,
      },
    },
    attr: { remark: "示例1" },
  });

  graphicLayer2.addGraphic(graphic);

  // graphicLayer.on(mars3d.EventType.drawRemovePoint, function (event) {
  //   console.log("移除点******", event);
  //   // deleteDot(graphic);
  //   // indexs -= 1;
  // });
}
function deleteDot(graphic) {
  // let arr = graphicLayer2.getGraphics();
  // let data = graphicLayer2.getGraphicById(arr[arr.length - 1]._id);
  // console.log(data, "datadatadata");
  // // graphicLayer2.removeGraphic(graphic);
  // graphicLayer2.remove(data);
}

//保存路线
export function savePath() {
  if (positions.length) {
    savePaths.push(positions);
    Message({
      message: "恭喜你，这是一条成功消息",
      type: "success",
    });
    console.log(JSON.stringify(savePaths), "savePaths");
    positions = [];
    indexs = 1;
    graphicLayer.clear();
    graphicLayer2.clear();
    // this.$GLOBAL.map.removeLayer(this.graphicLayer)
    // this.graphicLayer.endDraw()
  } else {
    Message({
      message: "请先在地图选点",
      type: "warning",
    });
  }
}

export function showAircraft() {
  savePaths = thePath.path;
  console.log(savePaths);
  if (savePaths.length) {
    removeLayer();
    let czmlObj = [
      {
        version: "1.0",
        id: "document",
        // clock: {
        //   // ISO 8601
        //   interval: "2018-09-15T04:00:00Z/2018-09-16T12:01:22.4928217109991Z",
        //   currentTime: "2018-09-15T04:00:00Z",
        //   multiplier: 1,
        // },
        clock: {
          // ISO 8601
          interval: `${beginDate}/${endDate}`,
          currentTime: beginDate,
          multiplier: 1,
        },
      },
    ];

    let index0 = 0;
    // console.log(savePaths);
    savePaths.forEach((item, elindex) => {
      index0 = 0;
      console.log(elindex);
      for (let i = 0; i < vehicleSum; i++) {
        if (i > 0) {
          index0 += intervalDate;
        }
        // 匀速
        // addData(time, index0, elindex);

        czmlObj.push(
          JSON.parse(JSON.stringify(addData(0, index0, elindex, i)))
        );
      }
    });

    console.log(czmlObj, "czmlObj");

    // 车模型过多拆分数据
    // if (czmlObj.length > 50) {
    //   variant(czmlObj, 50);
    //   return;
    // }

    // return;
    CzmlLayerData = {
      name: "汽车",
      data: czmlObj,
      // flyTo: true,
    };
    graphicLayer = new mars3d.layer.CzmlLayer(CzmlLayerData);
    Vue.$GLOBAL.map.addLayer(graphicLayer);
  } else {
    Message({
      message: "请先保存路线或添加路径",
      type: "warning",
    });
  }
}

function variant(czmlObj) {
  var arr = JSON.parse(JSON.stringify([]));
  arr = [];
  arr = czmlObj.splice(1, 50);
  arr.unshift(czmlObj[0]);

  layerGarp = new mars3d.layer.CzmlLayer({
    name: "汽车",
    data: arr,
  });
  Vue.$GLOBAL.map.addLayer(layerGarp);

  if (czmlObj.length > 50) {
    variant(czmlObj, 50);
  } else {
    console.log(5555);
    var arr2 = JSON.parse(JSON.stringify([]));
    arr2 = [];
    arr2 = czmlObj.splice(1, czmlObj.length);
    arr2.unshift(czmlObj[0]);

    if (arr2.length > 1) {
      console.log(arr2);
      layerGarp2 = new mars3d.layer.CzmlLayer({
        name: "汽车",
        data: arr2,
      });
      Vue.$GLOBAL.map.addLayer(layerGarp2);
    }
  }
}
function controlModel(type) {
  // if (CzmlLayerData && CzmlLayerData.data) {
  //   // for (let i = 0; i < CzmlLayerData.data.length; i++) {
  //   //   if (CzmlLayerData.data[i].model) CzmlLayerData.data[i].model.show = type;
  //   // }
  //   if (CzmlLayerData.data[1].model.show == !type) {
  //     console.log(type, "typetypetype");
  //     console.log(CzmlLayerData, "CzmlLayerDataCzmlLayerData");
  //     let obj = {
  //       show: true,
  //       // gltf: "/gltf/cart/kache3.gltf",
  //       gltf:
  //         basePathUrl +
  //         "gltf/cart/" +
  //         automobileList[generateRandomInteger(0, automobileList.length - 1)]
  //           .url,
  //       scale: 1,
  //       minimumPixelSize: 50,
  //     };
  //     let obj2 = {
  //       show: false,
  //       // gltf: "/gltf/cart/kache3.gltf",
  //       gltf: "",
  //       scale: 1,
  //       minimumPixelSize: 50,
  //     };
  //     graphicLayer.updateStyle({
  //       styleFieldOptions: {
  //         model: type ? obj : obj2,
  //       },
  //     });
  //   }
  // }
}

function removeLayer() {
  graphicLayer.clear();
  graphicLayer2.clear();
  Vue.$GLOBAL.map.clock.shouldAnimate = true;

  // Vue.$GLOBAL.map.removeLayer(graphicLayer, true);
  // graphicLayer = null;
}

function addData(time, index0, elindex, i) {
  // console.log(savePaths[elindex]);
  let obj = {
    name: i,
    availability: `${beginDate}/${endDate}`,
    orientation: { velocityReference: "#position" },
    position: {
      epoch: beginDate,

      cartographicDegrees: savePaths[elindex],
    },
    style: {
      minimumPixelSize: 100,
      // distanceDisplayCondition: true,
      // distanceDisplayCondition_near: 100,
      // distanceDisplayCondition_far: 1300,
      // distanceDisplayPoint: {
      //   // 当视角距离超过一定距离(distanceDisplayCondition_far定义的) 后显示为点对象的样式
      //   color: "#00ff00",
      //   pixelSize: 8,
      // },
    },
    // },
    model: {
      show: true,
      // gltf: "/gltf/cart/kache3.gltf",
      gltf:
        basePathUrl +
        "gltf/cart/" +
        automobileList[generateRandomInteger(0, automobileList.length - 1)].url,
      scale: 0.6,
      minimumPixelSize: 100,
      maximumScale: 1.5,
    },
    // label: {
    //   fillColor: {
    //     rgba: [0, 255, 255, 255],
    //   },
    //   font: "21pt Lucida Console",
    //   horizontalOrigin: "LEFT",
    //   outlineColor: {
    //     rgba: [0, 0, 0, 255],
    //   },
    //   outlineWidth: 2,
    //   pixelOffset: {
    //     cartesian2: [0, -30],
    //   },
    //   scale: 0.5,
    //   show: true,
    //   style: "FILL_AND_OUTLINE",
    //   text: createLicencePlate() + "--" + ++i,
    //   verticalOrigin: "CENTER",
    // },
  };
  // 变速
  // variableSpeed(0);
  constantSpeed(0, time, index0, elindex);
  return obj;
}

function constantSpeed(i, time, index0, elindex) {
  let index = i;
  if (i == 0) {
    savePaths[elindex][0] = index0;
    if (savePaths[elindex][index + 4]) {
      index += 4;
      constantSpeed(index, time, index0, elindex);
    }
  } else {
    if (savePaths[elindex][index]) {
      savePaths[elindex][index] = time + carVelocity + index0;
      index += 4;
      let a = time + carVelocity;
      constantSpeed(index, a, index0, elindex);
    }
  }
}
function variableSpeed(i) {
  let index = i;
  if (i == 0) {
    savePaths[0][0] = 0;
    if (savePaths[0][index + 4]) {
      index += 4;
      variableSpeed(index);
    }
  } else {
    if (savePaths[0][index]) {
      savePaths[0][index] = generateRandomInteger(index, index + 4);
      index += 4;
      variableSpeed(index);
    }
  }
}

export function suspend() {
  Vue.$GLOBAL.map.clock.shouldAnimate = !Vue.$GLOBAL.map.clock.shouldAnimate;
}
export function setVehicleSum(num) {
  vehicleSum = num;
}
export function setCarVelocity(num) {
  carVelocity = num;
}
export function setIntervalDate(num) {
  intervalDate = num;
}
export function reset() {
  positions = [];
  savePaths = JSON.stringify(savePaths);
  savePaths = "null";
  savePaths = JSON.parse(JSON.stringify([]));
  indexs = 1;
  vehicleSum = 100;
  carVelocity = 3;
  intervalDate = 3;
  pathData = null;
  pathData = JSON.parse(JSON.stringify([]));
  CzmlLayerData = null;
  graphicLayer.clear();
  graphicLayer2.clear();
  graphicLayer = null;
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);
  // layerGarp.clear();
  // layerGarp = null;
  // layerGarp = new mars3d.layer.GraphicLayer();
  // Vue.$GLOBAL.map.addLayer(layerGarp);
  // layerGarp2.clear();
  // layerGarp2 = null;
  // layerGarp2 = new mars3d.layer.GraphicLayer();
  // Vue.$GLOBAL.map.addLayer(layerGarp2);
  console.log(savePaths);
  console.log("重置成功!");
  Message({
    message: "重置成功",
    type: "success",
  });
}
function generateRandomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function createLicencePlate() {
  return getcity() + getarea() + getend5(5);
}

//省份生成
function getcity() {
  var id = Math.floor(Math.random() * 34);
  return citys[id];
}
//地区生成
function getarea() {
  var id = Math.floor(Math.random() * 17);
  return area[id];
}
//车牌后五位
function getend5(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    var id = Math.floor(Math.random() * 36);
    res += nums[id];
  }
  return res;
}
//日期转国际化
export function internationalizationDate(date) {
  let dateStart = "2019-03-27 12:40:00";
  let dateEnd = "2019-03-27 12:50:15";

  console.log(
    new Date(dateStart).toISOString() + "/" + new Date(dateEnd).toISOString()
  );

  console.log(new Date("2022-01-01 12:40:00").toUTCString());
  console.log(new Date("2022-01-01 12:50:15").toUTCString());
}
